import React from 'react';
import { ThemeBackgroundDecorations, ThemeDefinition } from './types';

const playfulBackgroundDecorations: ThemeBackgroundDecorations = {
  elements: [
    { className: 'playful-shape', style: { position: 'absolute', top: 92, right: -60, width: 220, height: 220, borderRadius: '50%', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.8, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape', style: { position: 'absolute', bottom: 120, left: -80, width: 260, height: 140, borderRadius: '999px', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-8deg)', opacity: 0.7, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: 220, left: 120, width: 72, height: 72, borderRadius: 8, backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(12deg)', opacity: 0.65, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', top: 50, left: '25%', width: 64, height: 64, borderRadius: 8, backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(45deg)', opacity: 0.6, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '45%', right: 24, width: 52, height: 52, borderRadius: '50%', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.55, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', bottom: 60, right: 80, width: 80, height: 80, borderRadius: '50% 0 50% 0', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(20deg)', opacity: 0.6, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '70%', left: -40, width: 160, height: 44, borderRadius: '999px', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(6deg)', opacity: 0.55, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', top: 150, left: '48%', width: 40, height: 40, borderRadius: '50%', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.58, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '58%', left: '38%', width: 54, height: 54, borderRadius: 8, backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(20deg)', opacity: 0.52, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', bottom: 26, left: '52%', width: 132, height: 32, borderRadius: '999px', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-8deg)', opacity: 0.5, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: 118, left: '8%', width: 34, height: 34, borderRadius: '50%', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.48, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden lg:block', style: { position: 'absolute', top: 178, right: '18%', width: 110, height: 28, borderRadius: '999px', backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-10deg)', opacity: 0.52, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '32%', left: '16%', width: 48, height: 48, borderRadius: '12px', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-16deg)', opacity: 0.54, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', top: '24%', right: '28%', width: 58, height: 58, borderRadius: '50% 50% 0 50%', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(18deg)', opacity: 0.49, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden lg:block', style: { position: 'absolute', top: '40%', left: '52%', width: 120, height: 24, borderRadius: '999px', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(12deg)', opacity: 0.46, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '52%', left: '10%', width: 30, height: 88, borderRadius: '999px', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(8deg)', opacity: 0.42, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '62%', right: '12%', width: 64, height: 64, borderRadius: '50%', backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.44, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden xl:block', style: { position: 'absolute', top: '72%', right: '30%', width: 74, height: 74, borderRadius: '16px', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-22deg)', opacity: 0.47, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', bottom: 160, left: '24%', width: 92, height: 26, borderRadius: '999px', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(14deg)', opacity: 0.45, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', bottom: 120, right: '42%', width: 42, height: 42, borderRadius: '50%', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.44, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden lg:block', style: { position: 'absolute', bottom: 96, right: 140, width: 120, height: 34, borderRadius: '999px', backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-14deg)', opacity: 0.42, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', bottom: 54, left: 110, width: 56, height: 56, borderRadius: '50% 0 50% 0', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-18deg)', opacity: 0.46, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden xl:block', style: { position: 'absolute', bottom: 32, left: '38%', width: 46, height: 110, borderRadius: '999px', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(10deg)', opacity: 0.38, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden sm:block', style: { position: 'absolute', top: 84, left: '64%', width: 28, height: 28, borderRadius: '50%', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.4, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', top: '48%', left: '72%', width: 36, height: 36, borderRadius: '8px', backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(28deg)', opacity: 0.4, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden lg:block', style: { position: 'absolute', top: '18%', left: '42%', width: 100, height: 20, borderRadius: '999px', backgroundColor: 'var(--warning)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-6deg)', opacity: 0.38, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden md:block', style: { position: 'absolute', bottom: '28%', right: '8%', width: 26, height: 86, borderRadius: '999px', backgroundColor: 'var(--primary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(-12deg)', opacity: 0.36, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden xl:block', style: { position: 'absolute', bottom: '36%', left: '58%', width: 84, height: 84, borderRadius: '50%', backgroundColor: 'var(--secondary)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', opacity: 0.34, zIndex: 0, pointerEvents: 'none' } },
    { className: 'playful-shape hidden lg:block', style: { position: 'absolute', top: '64%', right: '24%', width: 114, height: 22, borderRadius: '999px', backgroundColor: 'var(--accent)', border: '3px solid var(--foreground)', boxShadow: 'var(--shadow-hard)', transform: 'rotate(9deg)', opacity: 0.34, zIndex: 0, pointerEvents: 'none' } },
  ],
};

export const playfulTheme: ThemeDefinition = {
  id: 'playful',
  name: 'Playful (Classic)',
  description: 'Bold colors, rounded corners, and expressive shadows.',
  layoutMode: 'sidebar',
  headerPreferences: {
    showLogoDefault: false,
    showWordmarkDefault: true,
  },
  headerBehavior: {
    mobileHorizontalPadding: '3px',
    mobileInsetOffset: '4px',
  },
  sidebarBehavior: {
    compactHeightScrollFooter: true,
    zeroDesktopPanelPadding: true,
    navButtonGap: '4px',
    scrollerPaddingBottom: '6px',
    listPaddingBottom: '4px',
    itemPaddingBottom: '2px',
    hideStorageFooterOnMobile: true,
    mobileDrawerDocked: false,
    mobileDrawerBorderRadius: 'var(--nav-radius)',
    mobileDrawerMarginTop: 'calc(60px + var(--shell-gap))',
    mobileDrawerMarginBottom: 'var(--shell-gap)',
    mobileDrawerMaxHeight: 'calc(100vh - (60px + (var(--shell-gap) * 2)))',
    mobileDrawerWidth: '200px',
    mobileDrawerTop: '0',
    mobileDrawerBottom: 'auto',
  },
  backgroundDecorations: playfulBackgroundDecorations,
  layout: {
    desktop: {
      navPlacement: 'sidebar',
      headerFrameMode: 'inset',
      mobileHeaderInset: false,
      showHeaderToggleOnMobile: false,
      showDesktopNavItems: false,
      showStorageHeaderWidget: true,
      headerVersionPlacement: 'hidden',
      headerTitleInset: '0px',
      headerToggleMode: 'collapse',
      headerToggleWidth: '57px',
      headerToggleHeight: '40px',
      headerToggleRadius: 'var(--radius-ui)',
      headerToggleColor: 'inherit',
      headerUpdateIndicatorMode: 'playful',
      headerBackground: 'var(--card, #fffdf5)',
      headerBorder: 'var(--appbar-border)',
      headerBorderBottom: 'var(--appbar-border)',
      headerPattern: 'var(--appbar-pattern)',
      headerBackdropFilter: 'none',
      headerBorderRadius: 'var(--radius-ui)',
      headerMenuRadius: 'var(--radius-ui)',
      headerMenuBorder: '2px solid var(--border-strong)',
      headerMenuBackground: 'var(--card)',
      headerMenuShadow: 'none',
      shellBackground: 'linear-gradient(180deg, var(--card) 0%, var(--background) 55%, var(--background) 100%)',
      mainPadding: 'calc(80px + var(--shell-gap)) var(--shell-gap) var(--shell-gap) calc(var(--nav-width) + var(--shell-gap) * 2)',
      mainMarginTop: '0px',
      contentPadding: '5px 4px',
      contentMaxWidth: 'none',
      contentMarginInline: '0px',
      contentFrameBackground: 'var(--card)',
      contentFrameBorder: '2px solid var(--foreground)',
      contentFrameRadius: 'var(--radius-ui)',
      contentFrameShadow: 'var(--shadow-soft)',
    },
    mobile: {
      navPlacement: 'sidebar',
      headerFrameMode: 'inset',
      mobileHeaderInset: true,
      showHeaderToggleOnMobile: false,
      showDesktopNavItems: false,
      showStorageHeaderWidget: true,
      headerVersionPlacement: 'mobile',
      headerTitleInset: '0px',
      headerToggleMode: 'collapse',
      headerToggleWidth: '44px',
      headerToggleHeight: '44px',
      headerToggleRadius: 'var(--radius-ui)',
      headerToggleColor: 'inherit',
      headerUpdateIndicatorMode: 'playful',
      headerBackground: 'var(--card, #fffdf5)',
      headerBorder: 'var(--appbar-border)',
      headerBorderBottom: 'var(--appbar-border)',
      headerPattern: 'var(--appbar-pattern)',
      headerBackdropFilter: 'none',
      headerBorderRadius: 'var(--radius-ui)',
      headerMenuRadius: 'var(--radius-ui)',
      headerMenuBorder: '2px solid var(--border-strong)',
      headerMenuBackground: 'var(--card)',
      headerMenuShadow: 'none',
      shellBackground: 'linear-gradient(180deg, var(--card) 0%, var(--background) 55%, var(--background) 100%)',
      mainPadding: 'calc(64px + var(--shell-gap) * 2) 4px var(--shell-gap)',
      mainMarginTop: '0px',
      contentPadding: '8px 3px',
      contentMaxWidth: 'none',
      contentMarginInline: '0px',
      contentFrameBackground: 'var(--card)',
      contentFrameBorder: '2px solid var(--foreground)',
      contentFrameRadius: 'var(--radius-ui)',
      contentFrameShadow: 'var(--shadow-soft)',
    },
  },
  preview: React.createElement('div', {
    style: {
      padding: '20px',
      borderRadius: '12px',
      backgroundColor: '#fffdf5',
      border: '2px solid #1e293b',
      boxShadow: '4px 4px 0px 0px #1e293b',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minHeight: 80,
    }
  }, [
    React.createElement('div', { key: 'b1', style: { width: 44, height: 44, borderRadius: '6px', backgroundColor: '#f472b6', border: '2px solid #1e293b' } }),
    React.createElement('div', { key: 'b2', style: { width: 90, height: 16, borderRadius: '9999px', backgroundColor: '#fbbf24', border: '2px solid #1e293b' } })
  ]),
  tokens: {
    light: {
      'font-body': "'Outfit'",
      'font-display': "'Outfit'",
      background: '48 100% 98%', // #fffdf5
      foreground: '222 47% 11%', // #1e293b
      card: '0 0% 100%',
      'card-foreground': '222 47% 11%',
      popover: '0 0% 100%',
      'popover-foreground': '222 47% 11%',
      primary: '262 83% 58%', // #8b5cf6
      'primary-foreground': '0 0% 100%',
      secondary: '340 82% 70%', // #f472b6
      muted: '210 40% 96%', // #f1f5f9
      'muted-foreground': '215 16% 47%', // #64748b
      accent: '38 92% 55%',
      'accent-foreground': '0 0% 10%',
      destructive: '0 84% 60%',
      'destructive-foreground': '0 0% 100%',
      'success': '142 70% 40%',
      'success-foreground': '0 0% 100%',
      'warning': '38 92% 50%',
      'warning-foreground': '0 0% 10%',
      'info': '217 91% 55%',
      'info-foreground': '0 0% 100%',
      border: '214 32% 91%', // #e2e8f0
      'border-strong': '222 47% 11%',
      input: '0 0% 100%',
      'input-border': '214 32% 91%',
      'input-border-hover': '222 47% 11%',
      ring: '262 83% 58%',
      radius: '1.25rem',
      'radius-ui': '24px',
      'radius-input': '16px',
      'radius-thumb': '16px',
      'border-weight': '2px',
      'nav-radius': '24px',
      'action-bar-gap': '10px',
      'action-bar-gap-compact': '6px',
      'action-bar-padding-y': '8px',
      'action-bar-padding-x': '0px',
      'action-bar-foreground': '222 47% 11%',
      'action-bar-border': '214 32% 91%',
      'action-bar-hover-border': '222 47% 11%',
      'action-bar-disabled-foreground': '215 16% 47%',
      'snackbar-surface-background': 'rgba(255, 255, 255, 0.97)',
      'snackbar-surface-border': 'rgba(30, 41, 59, 0.16)',
      'snackbar-surface-foreground': '#1e293b',
      'overlay-backdrop-background': 'rgba(0, 0, 0, 0.5)',
      'overlay-backdrop-background-strong': 'rgba(0, 0, 0, 0.6)',
      'overlay-backdrop-filter': 'blur(4px)',
      'media-placeholder-background': '#1e293b',
      'media-placeholder-border': '1px solid rgba(30, 41, 59, 0.24)',
      'media-overlay-foreground': '#ffffff',
      'media-overlay-background': 'rgba(30, 41, 59, 0.68)',
      'media-overlay-background-strong': 'rgba(30, 41, 59, 0.82)',
      'media-overlay-danger-background': 'rgba(211, 47, 47, 0.95)',
      'media-overlay-selection-background': 'rgba(139, 92, 246, 0.22)',
      'media-overlay-delete-selection-background': 'rgba(220, 38, 38, 0.2)',
      'media-overlay-delete-indicator-background': 'rgba(220, 38, 38, 0.82)',
      'media-overlay-ignore-button-background': 'rgba(30, 41, 59, 0.72)',
      'media-overlay-text-shadow': 'drop-shadow(0px 2px 4px rgba(30, 41, 59, 0.55))',
      'video-modal-media-background': 'var(--card)',
      'video-modal-media-border': '2px solid var(--border-strong)',
      'video-modal-media-radius': 'var(--radius-ui)',
      'video-modal-media-max-height-mobile': '44vh',
      'video-modal-media-max-height-desktop': '60vh',
      'video-modal-media-overlay-gradient': 'linear-gradient(to bottom, rgba(30, 41, 59, 0.12) 0%, rgba(30, 41, 59, 0.48) 100%)',
      'video-modal-overlay-action-background': 'rgba(30, 41, 59, 0.76)',
      'video-modal-overlay-action-foreground': '#ffffff',
      'video-modal-overlay-action-size': '72px',
      'video-modal-overlay-action-icon-size': '48px',
      'video-modal-overlay-download-size': '90px',
      'video-modal-overlay-download-icon-size': '50px',
      'video-modal-overlay-corner-background': 'rgba(30, 41, 59, 0.62)',
      'video-modal-overlay-corner-foreground': '#ffffff',
      'video-modal-action-row-gap': '10px',
      'video-modal-action-row-padding-y': '2px',
      'video-modal-action-control-height': '28px',
      'video-modal-action-control-min-width': '28px',
      'video-modal-action-control-padding-x': '8px',
      'video-modal-content-gap': '12px',
      'video-modal-content-padding-mobile': '8px',
      'video-modal-content-padding-desktop': '12px',
      'video-modal-action-divider': 'var(--border-strong)',
      'video-modal-section-gap': '14px',
      'video-modal-delete-outline': 'var(--destructive)',
      'video-modal-delete-foreground': 'var(--destructive)',
      'video-modal-link-color': 'hsl(var(--primary))',
      'video-modal-info-bubble-background': 'var(--card)',
      'video-modal-info-bubble-foreground': 'var(--foreground)',
      'video-modal-info-bubble-border': '2px solid var(--border-strong)',
      'video-modal-info-bubble-shadow': 'var(--shadow-hard)',
      'auth-splash-background': 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      'auth-surface-background': 'var(--card)',
      'auth-surface-border': '4px solid var(--border-strong)',
      'auth-surface-shadow': '0 20px 60px rgba(0, 0, 0, 0.3)',
      'auth-surface-backdrop-filter': 'none',
      'auth-surface-transform': 'rotate(-0.5deg)',
      'auth-surface-padding': '40px',
      'auth-title-font-weight': '800',
      'auth-title-font-size': '3rem',
      'auth-title-letter-spacing': 'normal',
      'auth-title-text-shadow': 'none',
      'auth-subtitle-font-size': '1rem',
      'auth-button-text-transform': 'none',
      'auth-button-letter-spacing': 'normal',
      'linear-decor-blob-primary': 'radial-gradient(circle, rgba(139, 92, 246, 0.35) 0%, transparent 70%)',
      'linear-decor-blob-secondary': 'radial-gradient(circle, rgba(244, 114, 182, 0.28) 0%, transparent 70%)',
      'linear-decor-top-rail': 'linear-gradient(90deg, transparent, rgba(251, 191, 36, 0.45), transparent)',
      'fab-primary-bg': 'var(--primary)',
      'fab-primary-fg': 'var(--primary-foreground)',
      'fab-primary-hover-bg': 'var(--primary)',
      'fab-primary-hover-fg': 'var(--primary-foreground)',
      'fab-secondary-bg': 'var(--secondary)',
      'fab-secondary-fg': 'var(--secondary-foreground)',
      'fab-secondary-hover-bg': 'var(--secondary)',
      'fab-secondary-hover-fg': 'var(--secondary-foreground)',
      'fab-error-bg': 'var(--destructive)',
      'fab-error-fg': 'var(--destructive-foreground)',
      'fab-error-hover-bg': 'var(--destructive)',
      'fab-error-hover-fg': 'var(--destructive-foreground)',
      'selection-fab-size': '62px',
      'selection-fab-radius': '22px 14px 22px 14px',
      'selection-fab-border': '3px solid var(--foreground)',
      'selection-fab-shadow': 'var(--shadow-hard)',
      'selection-fab-shadow-hover': 'var(--shadow-hard-hover)',
      'selection-fab-shadow-active': 'var(--shadow-hard-active)',
      'selection-fab-icon-size': '22px',
      'selection-fab-badge-background': 'var(--warning)',
      'selection-fab-badge-foreground': 'var(--warning-foreground)',
      'selection-fab-badge-border': '3px solid var(--foreground)',
      'selection-fab-badge-shadow': 'var(--shadow-hard)',
      'selection-fab-badge-radius': '999px',
      'nav-hover-style': 'hard-shadow',
      'audio-chip-radius': 'var(--radius-ui)',
      'audio-chip-bg': 'transparent',
      'audio-chip-border': 'var(--border-strong)',
      'audio-chip-foreground': 'var(--foreground)',
      'audio-chip-icon': 'var(--foreground)',
      'audio-chip-shadow': 'var(--shadow-hard)',
      'audio-chip-shadow-hover': 'var(--shadow-hard-hover)',
      'video-chip-radius': 'var(--radius-ui)',
      'video-chip-bg': 'transparent',
      'video-chip-border': 'var(--border-strong)',
      'video-chip-foreground': 'var(--foreground)',
      'video-chip-icon': 'var(--foreground)',
      'video-chip-shadow': 'var(--shadow-hard)',
      'video-chip-shadow-hover': 'var(--shadow-hard-hover)',
      'audio-control-radius': 'var(--radius-ui)',
      'audio-control-border': 'var(--border-strong)',
      'audio-control-bg': 'var(--input)',
      'audio-control-foreground': 'var(--foreground)',
      'audio-control-shadow': 'var(--shadow-hard)',
      'audio-control-shadow-focus': 'var(--shadow-hard-hover)',
      shadow: '222 47% 11%',
      'shadow-soft': '8px 8px 0px 0px #e2e8f0',
      'shadow-hard': '3px 3px 0px 0px #1e293b',
      'shadow-hard-hover': '4px 4px 0px 0px #1e293b',
      'shadow-hard-active': '2px 2px 0px 0px #1e293b',
      'transition-bouncy': 'cubic-bezier(0.34, 1.56, 0.64, 1)',
      'card-hover-transform': 'translate(-2px, -2px) rotate(-0.5deg)',
      'card-hover-shadow': 'var(--shadow-hard-hover)',
      'shadow-input-rest': 'none',
      'shadow-input-focus': '0 0 0 2px var(--ring)',
      'dot-grid': 'rgba(30, 41, 59, 0.12)',
      'nav-border': '2px solid var(--foreground)',
      'nav-shadow': 'var(--shadow-hard)',
      'nav-item-bg-selected': '#fbbf24', // tertiary in playful
      'nav-item-text-selected': '#1e293b',
      'nav-item-border': '2px solid var(--foreground)',
      'nav-item-border-selected': '3px solid var(--foreground)',
      'nav-item-border-hover': '3px solid var(--foreground)',
      'nav-item-bg': 'transparent',
      'nav-item-bg-hover': 'rgba(251, 191, 36, 0.12)',
      'nav-item-shadow': 'none',
      'nav-item-shadow-selected': '3px 3px 0px 0px #1e293b',
      'nav-item-shadow-hover': '3px 3px 0px 0px #1e293b',
      'header-nav-active-color': 'var(--foreground)',
      'header-nav-default-color': 'var(--muted-foreground)',
      'header-subnav-active-color': 'var(--foreground)',
      'header-update-indicator-width': '40px',
      'header-update-indicator-height': '40px',
      'header-update-indicator-radius': 'var(--radius-ui)',
      'header-update-indicator-foreground': 'var(--warning-foreground)',
      'header-update-indicator-background': 'var(--warning)',
      'header-update-indicator-border': '2px solid var(--border-strong)',
      'header-update-indicator-shadow': 'var(--shadow-hard)',
      'mobile-subnav-surface-background': 'var(--card)',
      'mobile-subnav-surface-border-top': 'var(--nav-border)',
      'mobile-subnav-surface-radius': 'var(--radius-ui) var(--radius-ui) 0 0',
      'mobile-subnav-surface-margin-bottom': '-32px',
      'mobile-subnav-surface-padding-bottom': 'calc(8px + 32px)',
      'mobile-subnav-item-border': 'var(--nav-item-border)',
      'mobile-subnav-item-border-selected': 'var(--nav-item-border-selected)',
      'mobile-subnav-item-radius': 'var(--radius-ui)',
      'mobile-subnav-item-text-transform': 'none',
      'mobile-subnav-item-letter-spacing': 'normal',
      'mobile-primary-nav-surface-background': 'var(--card)',
      'mobile-primary-nav-surface-border-top': 'var(--nav-border)',
      'mobile-primary-nav-surface-radius': 'var(--radius-ui) var(--radius-ui) 0 0',
      'mobile-primary-nav-surface-shadow': 'var(--nav-shadow)',
      'mobile-primary-nav-active-color': 'var(--primary)',
      'mobile-primary-nav-active-background': 'transparent',
      'mobile-primary-nav-label-font-size': '0.65rem',
      'mobile-primary-nav-label-text-transform': 'none',
      'mobile-primary-nav-label-letter-spacing': 'normal',
      'channel-meta-chip-background': 'var(--card)',
      'channel-meta-chip-foreground': '#1e293b',
      'channel-meta-chip-border': '2px solid var(--border-strong)',
      'channel-meta-chip-shadow': 'var(--shadow-hard)',
      'channel-meta-chip-icon': 'var(--foreground)',
      'rating-chip-border': '2px solid var(--border-strong)',
      'rating-chip-shadow': 'var(--shadow-hard)',
      'settings-splash-shadow-hover': '6px 6px 0px 0px #fbbf24',
      'settings-splash-border': '#fbbf24',
      'chip-shadow-hover': 'none',
      'nav-item-transform': 'translate(0, 0)',
      'nav-item-transform-hover': 'translate(-2px, -2px)',
      'appbar-border': '2px solid var(--foreground)',
      'appbar-shadow': 'var(--shadow-hard)',
    },
    dark: {
      'font-body': "'Outfit'",
      'font-display': "'Outfit'",
      background: '222 47% 11%', // #0f172a
      foreground: '48 100% 98%', // #fffdf5
      card: '222 47% 11%',
      'card-foreground': '48 100% 98%',
      popover: '222 47% 11%',
      'popover-foreground': '48 100% 98%',
      primary: '258 90% 66%', // #8b5cf6
      'primary-foreground': '222 47% 11%',
      secondary: '340 82% 70%',
      muted: '222 47% 20%',
      'muted-foreground': '215 16% 70%',
      accent: '222 47% 20%',
      'accent-foreground': '0 0% 10%',
      destructive: '0 84% 40%',
      'destructive-foreground': '0 0% 100%',
      'success': '142 55% 45%',
      'success-foreground': '0 0% 10%',
      'warning': '38 85% 55%',
      'warning-foreground': '0 0% 10%',
      'info': '217 75% 65%',
      'info-foreground': '0 0% 10%',
      border: '222 47% 25%',
      'border-strong': '48 100% 98%',
      input: '222 47% 11%',
      'input-border': '222 47% 25%',
      'input-border-hover': '48 100% 98%',
      ring: '258 90% 66%',
      radius: '1.25rem',
      'radius-ui': '24px',
      'radius-input': '16px',
      'radius-thumb': '16px',
      'border-weight': '2px',
      'nav-radius': '24px',
      'action-bar-gap': '10px',
      'action-bar-gap-compact': '6px',
      'action-bar-padding-y': '8px',
      'action-bar-padding-x': '0px',
      'action-bar-foreground': '48 100% 98%',
      'action-bar-border': '222 47% 25',
      'action-bar-hover-border': '48 100% 98%',
      'action-bar-disabled-foreground': '215 16% 70%',
      'snackbar-surface-background': 'rgba(15, 23, 42, 0.97)',
      'snackbar-surface-border': 'rgba(255, 255, 255, 0.16)',
      'snackbar-surface-foreground': '#fffdf5',
      'overlay-backdrop-background': 'rgba(0, 0, 0, 0.5)',
      'overlay-backdrop-background-strong': 'rgba(0, 0, 0, 0.65)',
      'overlay-backdrop-filter': 'blur(4px)',
      'media-placeholder-background': '#0f172a',
      'media-placeholder-border': '1px solid rgba(255, 255, 255, 0.18)',
      'media-overlay-foreground': '#ffffff',
      'media-overlay-background': 'rgba(15, 23, 42, 0.72)',
      'media-overlay-background-strong': 'rgba(15, 23, 42, 0.86)',
      'media-overlay-danger-background': 'rgba(211, 47, 47, 0.95)',
      'media-overlay-selection-background': 'rgba(139, 92, 246, 0.28)',
      'media-overlay-delete-selection-background': 'rgba(220, 38, 38, 0.22)',
      'media-overlay-delete-indicator-background': 'rgba(220, 38, 38, 0.82)',
      'media-overlay-ignore-button-background': 'rgba(15, 23, 42, 0.76)',
      'media-overlay-text-shadow': 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.65))',
      'video-modal-media-background': 'var(--card)',
      'video-modal-media-border': '2px solid var(--border-strong)',
      'video-modal-media-radius': 'var(--radius-ui)',
      'video-modal-media-max-height-mobile': '44vh',
      'video-modal-media-max-height-desktop': '60vh',
      'video-modal-media-overlay-gradient': 'linear-gradient(to bottom, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.54) 100%)',
      'video-modal-overlay-action-background': 'rgba(0, 0, 0, 0.76)',
      'video-modal-overlay-action-foreground': '#ffffff',
      'video-modal-overlay-action-size': '72px',
      'video-modal-overlay-action-icon-size': '48px',
      'video-modal-overlay-download-size': '90px',
      'video-modal-overlay-download-icon-size': '50px',
      'video-modal-overlay-corner-background': 'rgba(0, 0, 0, 0.62)',
      'video-modal-overlay-corner-foreground': '#ffffff',
      'video-modal-action-row-gap': '10px',
      'video-modal-action-row-padding-y': '2px',
      'video-modal-action-control-height': '28px',
      'video-modal-action-control-min-width': '28px',
      'video-modal-action-control-padding-x': '8px',
      'video-modal-content-gap': '12px',
      'video-modal-content-padding-mobile': '8px',
      'video-modal-content-padding-desktop': '12px',
      'video-modal-action-divider': 'var(--border-strong)',
      'video-modal-section-gap': '14px',
      'video-modal-delete-outline': 'var(--destructive)',
      'video-modal-delete-foreground': 'var(--destructive)',
      'video-modal-link-color': 'hsl(var(--primary))',
      'video-modal-info-bubble-background': 'var(--card)',
      'video-modal-info-bubble-foreground': 'var(--foreground)',
      'video-modal-info-bubble-border': '2px solid var(--border-strong)',
      'video-modal-info-bubble-shadow': 'var(--shadow-hard)',
      'auth-splash-background': 'linear-gradient(135deg, #4c1d95 0%, #7e22ce 55%, #be185d 100%)',
      'auth-surface-background': 'rgba(15, 23, 42, 0.92)',
      'auth-surface-border': '4px solid var(--border-strong)',
      'auth-surface-shadow': '0 24px 64px rgba(0, 0, 0, 0.45)',
      'auth-surface-backdrop-filter': 'none',
      'auth-surface-transform': 'rotate(-0.5deg)',
      'auth-surface-padding': '40px',
      'auth-title-font-weight': '800',
      'auth-title-font-size': '3rem',
      'auth-title-letter-spacing': 'normal',
      'auth-title-text-shadow': 'none',
      'auth-subtitle-font-size': '1rem',
      'auth-button-text-transform': 'none',
      'auth-button-letter-spacing': 'normal',
      'linear-decor-blob-primary': 'radial-gradient(circle, rgba(139, 92, 246, 0.42) 0%, transparent 70%)',
      'linear-decor-blob-secondary': 'radial-gradient(circle, rgba(244, 114, 182, 0.36) 0%, transparent 70%)',
      'linear-decor-top-rail': 'linear-gradient(90deg, transparent, rgba(251, 191, 36, 0.5), transparent)',
      'fab-primary-bg': 'var(--primary)',
      'fab-primary-fg': 'var(--primary-foreground)',
      'fab-primary-hover-bg': 'var(--primary)',
      'fab-primary-hover-fg': 'var(--primary-foreground)',
      'fab-secondary-bg': 'var(--secondary)',
      'fab-secondary-fg': 'var(--secondary-foreground)',
      'fab-secondary-hover-bg': 'var(--secondary)',
      'fab-secondary-hover-fg': 'var(--secondary-foreground)',
      'fab-error-bg': 'var(--destructive)',
      'fab-error-fg': 'var(--destructive-foreground)',
      'fab-error-hover-bg': 'var(--destructive)',
      'fab-error-hover-fg': 'var(--destructive-foreground)',
      'selection-fab-size': '62px',
      'selection-fab-radius': '22px 14px 22px 14px',
      'selection-fab-border': '3px solid var(--foreground)',
      'selection-fab-shadow': 'var(--shadow-hard)',
      'selection-fab-shadow-hover': 'var(--shadow-hard-hover)',
      'selection-fab-shadow-active': 'var(--shadow-hard-active)',
      'selection-fab-icon-size': '22px',
      'selection-fab-badge-background': 'var(--warning)',
      'selection-fab-badge-foreground': 'var(--warning-foreground)',
      'selection-fab-badge-border': '3px solid var(--foreground)',
      'selection-fab-badge-shadow': 'var(--shadow-hard)',
      'selection-fab-badge-radius': '999px',
      'audio-chip-radius': 'var(--radius-ui)',
      'audio-chip-bg': 'transparent',
      'audio-chip-border': 'var(--border-strong)',
      'audio-chip-foreground': 'var(--foreground)',
      'audio-chip-icon': 'var(--foreground)',
      'audio-chip-shadow': 'var(--shadow-hard)',
      'audio-chip-shadow-hover': 'var(--shadow-hard-hover)',
      'video-chip-radius': 'var(--radius-ui)',
      'video-chip-bg': 'transparent',
      'video-chip-border': 'var(--border-strong)',
      'video-chip-foreground': 'var(--foreground)',
      'video-chip-icon': 'var(--foreground)',
      'video-chip-shadow': 'var(--shadow-hard)',
      'video-chip-shadow-hover': 'var(--shadow-hard-hover)',
      'audio-control-radius': 'var(--radius-ui)',
      'audio-control-border': 'var(--border-strong)',
      'audio-control-bg': 'var(--input)',
      'audio-control-foreground': 'var(--foreground)',
      'audio-control-shadow': 'var(--shadow-hard)',
      'audio-control-shadow-focus': 'var(--shadow-hard-hover)',
      /* Chip and rating shadows */
      'chip-shadow': 'none',
      'chip-shadow-hover': 'none',
      'rating-chip-border': '2px solid var(--border-strong)',
      'rating-chip-shadow': 'var(--shadow-hard)',
      'rating-chip-shadow-hover': 'none',
      'status-chip-max-width': '140px',
      'rating-chip-max-width': '120px',
      'nav-hover-style': 'hard-shadow',
      shadow: '48 100% 98%',
      'shadow-soft': '8px 8px 0px 0px rgba(0,0,0,0.3)',
      'shadow-hard': '3px 3px 0px 0px #fffdf5',
      'shadow-hard-hover': '4px 4px 0px 0px #fffdf5',
      'shadow-hard-active': '2px 2px 0px 0px #fffdf5',
      'transition-bouncy': 'cubic-bezier(0.34, 1.56, 0.64, 1)',
      'card-hover-transform': 'translate(-2px, -2px) rotate(-0.5deg)',
      'card-hover-shadow': 'var(--shadow-hard-hover)',
      'shadow-input-rest': 'none',
      'shadow-input-focus': '0 0 0 2px var(--ring)',
      'dot-grid': 'rgba(255, 255, 255, 0.1)',
      'nav-border': '2px solid var(--foreground)',
      'nav-shadow': 'var(--shadow-hard)',
      'nav-item-bg-selected': '#fbbf24',
      'nav-item-text-selected': '#1e293b',
      'nav-item-border': '2px solid var(--foreground)',
      'nav-item-border-selected': '3px solid var(--foreground)',
      'nav-item-border-hover': '3px solid var(--foreground)',
      'nav-item-bg': 'transparent',
      'nav-item-bg-hover': 'rgba(255, 255, 255, 0.08)',
      'nav-item-shadow': 'none',
      'nav-item-shadow-selected': '3px 3px 0px 0px #fffdf5',
      'nav-item-shadow-hover': '3px 3px 0px 0px #fffdf5',
      'header-nav-active-color': 'var(--foreground)',
      'header-nav-default-color': 'var(--muted-foreground)',
      'header-subnav-active-color': 'var(--foreground)',
      'header-update-indicator-width': '40px',
      'header-update-indicator-height': '40px',
      'header-update-indicator-radius': 'var(--radius-ui)',
      'header-update-indicator-foreground': 'var(--warning-foreground)',
      'header-update-indicator-background': 'var(--warning)',
      'header-update-indicator-border': '2px solid var(--border-strong)',
      'header-update-indicator-shadow': 'var(--shadow-hard)',
      'mobile-subnav-surface-background': 'var(--card)',
      'mobile-subnav-surface-border-top': 'var(--nav-border)',
      'mobile-subnav-surface-radius': 'var(--radius-ui) var(--radius-ui) 0 0',
      'mobile-subnav-surface-margin-bottom': '-32px',
      'mobile-subnav-surface-padding-bottom': 'calc(8px + 32px)',
      'mobile-subnav-item-border': 'var(--nav-item-border)',
      'mobile-subnav-item-border-selected': 'var(--nav-item-border-selected)',
      'mobile-subnav-item-radius': 'var(--radius-ui)',
      'mobile-subnav-item-text-transform': 'none',
      'mobile-subnav-item-letter-spacing': 'normal',
      'mobile-primary-nav-surface-background': 'var(--card)',
      'mobile-primary-nav-surface-border-top': 'var(--nav-border)',
      'mobile-primary-nav-surface-radius': 'var(--radius-ui) var(--radius-ui) 0 0',
      'mobile-primary-nav-surface-shadow': 'var(--nav-shadow)',
      'mobile-primary-nav-active-color': 'var(--primary)',
      'mobile-primary-nav-active-background': 'transparent',
      'mobile-primary-nav-label-font-size': '0.65rem',
      'mobile-primary-nav-label-text-transform': 'none',
      'mobile-primary-nav-label-letter-spacing': 'normal',
      'channel-meta-chip-background': 'var(--card)',
      'channel-meta-chip-foreground': '#fffdf5',
      'channel-meta-chip-border': '2px solid var(--border-strong)',
      'channel-meta-chip-shadow': 'var(--shadow-hard)',
      'channel-meta-chip-icon': 'var(--foreground)',
      'settings-splash-shadow-hover': '6px 6px 0px 0px #fbbf24',
      'settings-splash-border': '#fbbf24',
      'nav-item-transform': 'translate(0, 0)',
      'nav-item-transform-hover': 'translate(-2px, -2px)',
      'appbar-border': '2px solid var(--foreground)',
      'appbar-shadow': 'var(--shadow-hard)',
    },
  },
};
